import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

import WhyHostFormBlock7 from '../../../../components/siteadmin//WhyHostPageSettings/WhyHostFormBlock7/WhyHostFormBlock7';

import s from './AddReviewsWhyHost.css';

const AddReviewsWhyHost = () => {

    let initialValues = {
        dynamicAdminReviews: [{
        }]
    };

    return <WhyHostFormBlock7 initialValues={initialValues} />
}

export default withStyles(s)(AddReviewsWhyHost);